import {DefaultDataService, DefaultDataServiceConfig, Logger, QueryParams} from "@ngrx/data";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {HttpModelConverter} from "../../../converter/httpModel.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {UrlHelper} from "../../../../../store/core/url/urlHelper";
import {Page} from "../../../../../shared/model/core/page.model";
import {PlainDtoModel} from "../../../../common/entity/dto/plain/plainDto.model";
import {PageHelperV2} from "../../../../../store/core/pagination/pageHelperV2";

export abstract class AbstractDataServiceV2<StoredEntity extends PlainDtoModel, Converter extends HttpModelConverter<StoredEntity>> extends DefaultDataService<StoredEntity> {

    readonly storedEntityConverter: Converter;

    protected constructor(entityName: string, http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, storedEntityConverter: Converter) {
        super(entityName, http, httpUrlGenerator, config);
        this.storedEntityConverter = storedEntityConverter;
    }

    get httpClient(): HttpClient {
        return this.http;
    }

    getWithQuery(queryParams: QueryParams | string): Observable<StoredEntity[]> {
        throw new Error("Not supported. use getMultipleWithQuery instead");
    }


    getMultipleWithQuery<Entity, Converter extends HttpModelConverter<Entity>>(converter: Converter, path: string, params?: string | QueryParams): Observable<Page<Entity>> {
        const formattedPath = this.buildPath(true, undefined, path);
        return this.http.get<any>(UrlHelper.formatUrl(formattedPath, params))
            .pipe(
                map((data: any) => {
                    return PageHelperV2.convertRestPageToStorePage(data, converter);
                }),
            );
    }

    getOneWithQuery<Entity, Converter extends HttpModelConverter<Entity>>(converter: Converter, path: string, params?: string | QueryParams): Observable<Entity> {
        const formattedPath = this.buildPath(false, undefined, path);
        return this.http.get<Entity>(UrlHelper.formatUrl(formattedPath, params)).pipe(map(value => converter.convert(value)));

    }


    executeUpdate(id: number | string, payload: any, path?: string): Observable<StoredEntity> {
        return this.execute('PUT', this.buildPath(false, id, path), payload).pipe(map(value => this.convert(value)));
    }

    executeCreate(payload: any, path?: string): Observable<StoredEntity> {
        return this.execute('POST', this.buildPath(false, undefined, path), payload).pipe(map(value => this.convert(value)));
    }

    executeDelete(id: number | string): Observable<void> {
        return this.executeDeleteWithQueryParams(id, '');
    }

    executeDeleteWithQueryParams(id: number | string, queryParams: string): Observable<void> {
        return this.execute('DELETE', this.buildPath(false, id, undefined) + queryParams);
    }

    buildPath(plural: boolean, id: string | number, path: string) {
        let fullPath = plural ? this.entitiesUrl : this.entityUrl;
        if (id) {
            fullPath += id + "/"
        }
        if (path) {
            fullPath += path;
        }

        if (fullPath.endsWith('/')) {
            fullPath = fullPath.substring(0, fullPath.length - 1);
        }

        return fullPath;
    }

    getEntityUrl(): string {
        return this.entityUrl;
    }

    protected convert(data: StoredEntity): StoredEntity {
        // console.logByType['converter', data, this.storedEntityConverter.convert(data), this.storedEntityConverter]);
        return this.storedEntityConverter.convert(data);
    }
}